<script setup>
import DocumentHistoryDialog from '../editor/history/DocumentHistoryDialog.vue';
import BillingDialog from '../payments/BillingDialog.vue';

const model = defineModel({default: null})

</script>
<template>
    <DocumentHistoryDialog v-if="model === 'DocumentHistory'" @close="model=null"/>
    <BillingDialog v-if="model === 'Billing'" @close="model=null" />  
</template>